import React from 'react';
import {injectIntl} from "react-intl";
import './AssignedSafesDetail.css'

class AssignedSafesDetail extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {intl:{formatMessage}, safe, pageBreak} = this.props;
    const {customer, userVehicle, rentalVehicle, type} = this.props.details;

    const safeTypeI18nKey = type === 'DROPOFF' ? 'general-services.carDropOff.keySafe' : 'general-services.carPickUp.keySafe'

    return (
      <div className="col-sm-4 col-lg-4 daily-safe-details">

        <div className="choice-card">
          <header className="choice-card__header">
              <h4 className="choice-card__title">{formatMessage({id:'safe.number'})} {safe.safeNumber}</h4><br/>
              <h4 className="choice-card__title">{formatMessage({id:'safe.code'})} {safe.safeCode}</h4>
          </header>
          <div className="choice-card__body">
            <h3>{formatMessage({id:safeTypeI18nKey})}</h3>
            <h3 className="box__subtitle">{formatMessage({id:'customer.details.title'})}</h3>
            <div>
              <span className="txt-muted">{formatMessage({id:'summary.customer'})}: </span>{`${customer.firstName} ${customer.lastName}`}
            </div>
            <div>
              <span className="txt-muted">{formatMessage({id:'summary.car'})}: </span>{`${userVehicle.brand} ${userVehicle.model}`}
            </div>
            <div>
              <span className="txt-muted">{formatMessage({id:'summary.license-plate'})}: </span>{userVehicle.licensePlate}
            </div>
            <h3 className="box__subtitle">{formatMessage({id:'mobility.rental-car'})}</h3>
            {!rentalVehicle && formatMessage({id:'safe.no-rental'})}
            {rentalVehicle && <React.Fragment>
              <div>
                <span className="txt-muted">{formatMessage({id:'summary.car'})}: </span>{rentalVehicle.brand}
              </div>
              <div>
                <span className="txt-muted">{formatMessage({id:'summary.license-plate'})}: </span>{rentalVehicle.licensePlate}
              </div>
            </React.Fragment>}
          </div>
        </div>

        {pageBreak === true && <div key={'break-' + new Date()} className="page-break"></div>}

      </div>
    )
  }
}

export default injectIntl(AssignedSafesDetail);



// WEBPACK FOOTER //
// ./src/components/safes/planning/AssignedSafesDetail.js